import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const BackButton = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="hidden md:block fixed top-24 left-25 z-50">
      {/* <button
        onClick={handleBack}
        className="btn btn-circle btn-primary shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 text-white bg-opacity-80"
        aria-label="Back"
      >
        <FontAwesomeIcon icon={faArrowLeft} className="text-base" />
      </button> */}
    </div>
  );
};

export default BackButton;




// import React, { useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import './BackButton.css'; // Import the updated CSS
// import { useTranslation } from 'react-i18next';

// const BackButton = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     // Ensure no re-renders or unnecessary API calls when returning to the previous page
//     return () => {
//       // Cleanup code if needed when leaving the page
//     };
//   }, [location]);

//   const handleBack = () => {
//     navigate(-1); // Navigate back to the previous page
//   };

//   return (
//     <div className="button-container">
//       <button className="back-button" onClick={handleBack}>
//         <span className="icon"></span>
//       </button>
//     </div>
//   );
// };

// export default BackButton;